import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors as c } from '../../../styles/Variables'

export const HomeWrapper = styled.div`
  /* Must stay 100vw, NOT 100%. The app shell (_app.js) centers every page in a
     flex column with align-items:center, which does NOT stretch children — so
     100vw is load-bearing to force full-viewport width. With 100% the container
     collapses/overflows to content width and the mobile Services Swiper + fill
     images mis-size ("blown out"). body has overflow-x:hidden to absorb the
     scrollbar-width overflow that 100vw introduces on desktop. */
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`

// Consumed by home/2023/data.js (service cards).
export const CardButton = styled.div`
  width: 100%;
  height: 544px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  cursor: pointer;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), 90%, rgba(0,0,0, 1));
    z-index: 30;
  }

  img {
    z-index: 10;
    object-fit: cover;
  }

  div {
    z-index: 40;
    width: auto;
    padding: 14px 50px;
    border: 1px solid #FFF;
    margin-bottom: 36px;
  }
`

// Consumed by home/2023/RatingsSection.js AND pages/weddings.js — must stay shared.
export const RatingsWrapper = styled.div`
  width: 100%;
  padding: 50px 16px;
  background-color: ${c.cobalt};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 1600px;
  z-index: 0;

  ${mq('max', '768px')} {
    padding: 38px 16px;
  }

  .swiper-container-container {
    width: 610px;

    ${mq('max', '768px')} {
      width: 100%;
    }

    .swiper-container {
      position: relative;
      padding-bottom: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      .custom-next-button {
        background-image: url('/images/arrow-right.png');
        background-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        border: none;
        height: 32px;
        width: 32px;
        position: absolute;
        bottom: 0;
        right: 40%;
        z-index: 999;
        cursor: pointer;
      }

      .custom-prev-button {
        background-image: url('/images/arrow-left.png');
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        background-color: transparent;
        border: none;
        height: 32px;
        width: 32px;
        position: absolute;
        bottom: 0;
        left: 40%;
        z-index: 999;
        cursor: pointer;
      }
    }

    .rating {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;

      ${mq('max', '768px')} {
        max-width: 90%;
        margin: 0 auto;
      }

      .star-container {
        display: flex;
        flex-direction: row;
        gap: 3px;
        margin-bottom: 12px;
      }
    }
  }
`
